import { CIDS } from '../../components/ProductsTable/constants';
import { BaseAlgorithm } from './BaseAlgorithm';
import { debugLog, rankDebugLogEnable } from './ranking';

export class IgbtAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVbr = 2;
		this.normIc = 5;

		this.weightVbr = 0.3;
		this.weightIc = 0.2;

		this.rVbc = 0;
		this.rIc = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_Vbc,rVbc,rankVbr,part_Ic,rIc,rankIc,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Breakdown voltage  V(BR)CES Typ (V)-----------------------------------------------------

		[this.rankVbr, this.rVbc] = this.calculateRankDualSliderGTE(CIDS.BREAKDOWN_VOLTAGE_CES, product, this.normVbr);

		// ---------------------------------------------Collector current  IC Max (A)-----------------------------------------------------

		[this.rankIc, this.rIc] = this.calculateRankDualSliderGTE(CIDS.COLLECTOR_CURRENT, product, this.normIc);

		// --------------------------------------------------------------------------------------------------------------

		let feRank = this.weightVbr * this.rankVbr + this.weightIc * this.rankIc;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVbr - this.weightIc) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
